import React, { useState } from 'react';
import {
    Box,
    Flex,
    Heading,
    HStack,
    Icon,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    useColorMode,
    VStack,
} from '@chakra-ui/react';
import {
    AiOutlineTrophy,
    AiOutlineTeam,
    AiOutlineUser,
    AiOutlineBarChart,
    AiOutlineCheckCircle,
    AiOutlineLineChart,
    AiOutlineBell,
} from 'react-icons/ai';
import DesempenhoVendas from './DesempenhoVendas';
import EmManutencao from '../../../../components/UI/EmManutencao';

const ABAS = [
    { label: 'Desempenho',     icon: AiOutlineBarChart },
    { label: 'Metas Pessoais', icon: AiOutlineUser },
    { label: 'Metas Gerais',   icon: AiOutlineTeam },
];

// Pílulas de aba no mesmo padrão da tela Relatórios
const tabStyle = {
    borderRadius: 'lg',
    fontWeight: '600',
    fontSize: 'sm',
    color: 'textSecondary',
    border: '1px solid',
    borderColor: 'borderSubtle',
    px: 4,
    py: 2,
    _selected: { bg: 'secondarySubtle', color: 'secondary', borderColor: 'rgba(1,233,117,0.45)', fontWeight: '800' },
    _hover: { bg: 'surfaceHover', color: 'textPrimary' },
};

const Metas = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const { colorMode } = useColorMode();

    return (
        <VStack align="stretch" spacing={6}>
            {/* Header (mesmo padrão da tela Relatórios) */}
            <Flex justify="space-between" align="center" wrap="wrap" gap={4}
                p={6} borderRadius="2xl" border="1px solid" borderColor="borderPrimary"
                bg={colorMode === 'dark' ? 'linear-gradient(135deg, rgba(21,23,25,0.9) 0%, rgba(26,29,32,0.9) 100%)' : 'surface'} position="relative" overflow="hidden">
                <Box position="absolute" top="-100px" right="-100px" w="300px" h="300px" bg="radial-gradient(circle, rgba(1,233,117,0.12) 0%, transparent 70%)" pointerEvents="none" />
                <HStack spacing={4}>
                    <Flex w="50px" h="50px" borderRadius="xl" bg="rgba(1,233,117,0.15)" border="1px solid" borderColor="rgba(1,233,117,0.3)" align="center" justify="center">
                        <Icon as={AiOutlineTrophy} color="secondary" boxSize="26px" />
                    </Flex>
                    <VStack align="start" spacing={0}>
                        <Heading size="lg" color="textPrimary" fontWeight="900">Metas</Heading>
                        <Text color="textSecondary" fontSize="sm">Desempenho de vendas e metas do time — acompanhe resultados e rankings.</Text>
                    </VStack>
                </HStack>
            </Flex>

            {/* Abas (pílulas em container, mesmo padrão da tela Relatórios) */}
            <Tabs variant="unstyled" index={tabIndex} onChange={setTabIndex}>
                <TabList bg="surface" border="1px solid" borderColor="borderPrimary" borderRadius="xl" p={1} gap={1} mb={6} width="fit-content" flexWrap="wrap">
                    {ABAS.map((a) => (
                        <Tab key={a.label} {...tabStyle}>
                            <HStack spacing={2}>
                                <Icon as={a.icon} boxSize="16px" />
                                <Text>{a.label}</Text>
                            </HStack>
                        </Tab>
                    ))}
                </TabList>

                <TabPanels>
                    <TabPanel p={0}>
                        <DesempenhoVendas />
                    </TabPanel>
                    <TabPanel p={0}>
                        <EmManutencao
                            titulo="Metas Pessoais"
                            descricao="A tela de metas pessoais está em manutenção e ainda não está disponível. Em breve você poderá criar e acompanhar suas metas individuais por aqui."
                            recursos={[
                                { icon: AiOutlineCheckCircle, title: 'Minhas metas', desc: 'Criação e acompanhamento' },
                                { icon: AiOutlineLineChart, title: 'Progresso', desc: 'Evolução em tempo real' },
                                { icon: AiOutlineBell, title: 'Alertas', desc: 'Avisos de prazo e risco' },
                            ]}
                        />
                    </TabPanel>
                    <TabPanel p={0}>
                        <EmManutencao
                            titulo="Metas Gerais"
                            descricao="A tela de metas gerais do time está em manutenção e ainda não está disponível. Em breve a gestão poderá definir metas coletivas e acompanhar o desempenho do time por aqui."
                            recursos={[
                                { icon: AiOutlineTeam, title: 'Metas do time', desc: 'Objetivos coletivos' },
                                { icon: AiOutlineTrophy, title: 'Ranking', desc: 'Comparativo de vendedores' },
                                { icon: AiOutlineLineChart, title: 'Projeções', desc: 'Estimativas de fechamento' },
                            ]}
                        />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </VStack>
    );
};

export default Metas;
